import React,{useState,useEffect} from 'react'
import { Heading } from './destination'
import Navbar from './Navbar'
import dt from "../data.json"
import"./style/technology.css"
const Technology = () => {
  const[i,setI]=useState(0);
    const [Bgimg, setBgimg] = useState(`url("./assets/technology/background-technology-desktop.jpg")`);
    useEffect(() => {
      if(window.innerWidth<=768&&window.innerWidth>450){
        setBgimg(`url("./assets/technology/background-technology-tablet.jpg")`)
    }else if(window.innerWidth<=660){
        setBgimg(`url("./assets/technology/background-technology-mobile.jpg")`)
    }
    }, [Bgimg])

const changeContent=(e)=>{
setI(e);
// console.log(dt.technology[e]);
}
    
  return (
    <div className="tech" style={{background:`${Bgimg}`}}>
<Navbar/>
<div className="tech-container">

    <Heading num={"03"} title={"SPACE LAUNCH 101"}/>

    <div className="content">
        <div className="innerNav">
            <span className={i===0?`num active`:`num`}  onClick={()=>changeContent(0)}>01</span>
            <span className={i===1?`num active`:`num`} onClick={()=>changeContent(1)}>02</span>
            <span className={i===2?`num active`:`num`}  onClick={()=>changeContent(2)}>03</span>
</div>
        <div className="text">
            <div className="text-content">

<span className="sub-heading">THE TERMINOLOGY…</span>
<span className="name">{dt.technology[i].name}</span>
<span className="description">
{dt.technology[i].description}
</span>
            </div>
       
</div>
        <div className="tech-img"><img src={window.innerWidth>=768?dt.technology[i].images.portrait:dt.technology[i].images.landscape} alt="" /></div>
    </div>
</div>

    </div>
  )
}

export default Technology